import type { PixelEvent } from '@/events';

import type { IEventQueue } from './types';

export class MemoryQueue implements IEventQueue {
  private readonly items: PixelEvent[] = [];

  enqueue(event: PixelEvent): void {
    this.items.push(event);
  }

  dequeue(): PixelEvent | undefined {
    return this.items.shift();
  }

  peek(): PixelEvent | undefined {
    return this.items[0];
  }

  size(): number {
    return this.items.length;
  }

  clear(): void {
    this.items.length = 0;
  }

  remove(predicate: (event: PixelEvent) => boolean): number {
    const before = this.items.length;
    const kept = this.items.filter(event => !predicate(event));
    this.items.length = 0;
    this.items.push(...kept);
    return before - kept.length;
  }

  isEmpty(): boolean {
    return this.items.length === 0;
  }

  getAll(): readonly PixelEvent[] {
    return [...this.items];
  }
}
